/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Aaf_Embed_Self_ContainedInputs */



/**
* | output |
* | --- |
* | "AAF Embed (Self Contained)" |
*
* @param {Subtitle_Export_Aaf_Embed_Self_ContainedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_aaf_embed_self_contained = /** @type {((inputs?: Subtitle_Export_Aaf_Embed_Self_ContainedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Aaf_Embed_Self_ContainedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("AAF Embed (Autonome)")
	if (locale === "de") return /** @type {LocalizedString} */ ("AAF-Einbettung (eigenständig)")
	if (locale === "it") return /** @type {LocalizedString} */ ("AAF Embed (autosufficiente)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("AAF Embed (автономный)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Integración de AAF (autónoma)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AAF嵌入式（独立式）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AAF埋め込み（自己完結型）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एएएफ एम्बेड (स्वयं-निहित)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporação AAF (Autocontida)")
	return /** @type {LocalizedString} */ ("AAF Embed (Self Contained)")
});